import { ReviewLevel, ProductVertical } from '@scale/shared/defaults';
import { TaskType } from '@scale/shared-types';
import { QMProject } from '@scale/shared/qm/qmRequestTypes';
import configJson from './configJson';
import { maybeReplaceInternalUrlsWithCorp } from './maybeReplaceInternalUrlsWithCorp';

const mockedConfigObject: object = {
  config: configJson,
  version: 0,
};
export async function apiFetch(context: any, url: string): Promise<any> {
  console.info('storybook stubbing fetch', url);

  if (url.startsWith('internal/linting')) {
    const parts = url.split('/');
    const id = parts[parts.length - 2];
    const assetUrl = `https://assets.storybook.internal.scale.com/fixtures/remotasks/linting/${id}.json`;
    try {
      console.info('trying to fetch lint from', assetUrl, 'instead of', url);

      return await (await fetch(maybeReplaceInternalUrlsWithCorp(assetUrl))).json();
    } catch (e) {
      console.info('stubbing lint and returning no errors');
      return {
        lintVerdict: 'noaction',
        lintResults: {},
      };
    }
  } else if (url.startsWith('corp-api/qm/projects')) {
    const qmProject: QMProject = {
      fav: false,
      id: '5e567735b5b72c00100e9014',
      name: 'instanceseg_v2020-1',
      createdAt: new Date().toISOString(),
      permissionGroup: {
        id: '5e567735b5b72c00100e9013',
        name: 'Neutron_instance_segmentation_v2020_polygon_group',
      },
      subtaskCounts: { [ReviewLevel.Corp]: 0 },
      taskCount: 246581,
      taskCustomer: {
        company: 'nuTonomy',
        email: 'holger.caesar@motional.comabcdef',
        id: '59f11892c11cb20007a6998a',
      },
      productVertical: ProductVertical.TwoDee,
      taskType: TaskType.ImageAnnotation,
      taskTemplateVersion: -1,
      projectParamVersion: -1,
      subtasksCompletedThisWeek: 10,
      tasksCompletedThisWeek: 20,
      workerSources: [],
    };

    return Promise.resolve(qmProject);
  } else if (url.startsWith('corp-api/lookup/5e567735b5b72c00100e9014/config?')) {
    return Promise.resolve({ config: configJson, version: 0 });
  } else if (url.match(/corp-api\/lookup\/\w+\/config\?/)) {
    return Promise.resolve(mockedConfigObject);
  } else if (url.startsWith('internal/semseg2D/5ff95006e56dc600185d06ea/project_subtask_labels')) {
    return Promise.resolve([{ label: 'ego_lane', colorIndex: 1 }]);
  } else if (url.startsWith('internal/semseg2D')) {
    return Promise.resolve({});
  } else if (url.startsWith('corp-api/project-params/validate')) {
    return Promise.resolve({ isValid: true });
  } else if (url.startsWith('internal/gis/gm-mapping-tasks')) {
    // todo: update with actual tasks from the gm test proj
    // BBox defined by  l t r d --> meaning x_left, y_top, x_right, y_bottom
    const topLeftTask = {
      id: 1,
      metadata: { bounding_box: [1024, 0, 3584, 2560] },
    };
    const topRightTask = {
      id: 2,
      metadata: {
        bounding_box: [3584, 0, 6144, 2560],
        auditUrl: 'https://dashboard.scale.com/audit?taskId=624babc635f34c0011873a74',
      },
    };
    const bottomLeftTask = {
      id: 3,
      metadata: {
        bounding_box: [1024, 2560, 3584, 5120],
        auditUrl: 'https://dashboard.scale.com/audit?taskId=624babd829a40100257fa661',
      },
    };
    const bottomRightTask = {
      id: 4,
      metadata: {
        bounding_box: [3584, 2560, 6144, 5120],
        auditUrl: 'https://dashboard.scale.com/audit?taskId=625055a4682944f7f7353afb',
      },
    };
    const tasksList = [topLeftTask, topRightTask, bottomLeftTask, bottomRightTask];
    const xOffset = 1024;
    const yOffset = 0;
    const size = 2560;
    for (let dx = -80; dx < 30; dx++) {
      for (let dy = -30; dy < 80; dy++) {
        if ((dx === 0 || dx === 1) && (dy === 0 || dy === 1)) {
          // These are the above 4 tasks
          continue;
        }
        const left = xOffset + dx * size;
        const top = yOffset + dy * size;
        const right = left + size;
        const bottom = top + size;
        const dummyTask = {
          id: tasksList.length + 1,
          metadata: {
            bounding_box: [left, top, right, bottom],
          },
        };
        tasksList.push(dummyTask);
      }
    }
    return Promise.resolve({ tasks: tasksList });
  }

  return Promise.reject(new Error());
}
